<div class="row" style="padding: 0">
  @if (!isLoading && !noData) {
    <div>
      <app-highcharts-generic
        [chartheight]="height"
        [options]="top_five_options"
        [series]="top_five_series"
      ></app-highcharts-generic>
    </div>
  }
  @if (!isLoading && noData) {
    <div class="noDataZiti">No Data</div>
  }
  <app-loader [isLoading]="isLoading"></app-loader>
</div>
